/**
 * Cart total price component
 *
 * @module cart-total-price
 * @version 1.0.0
 * @extends HTMLElement
 */

customElements.component = "cart-total-price";

if (!customElements.get(customElements.component)) {
  class cartTotalPrice extends HTMLElement {
    /**
     * Minicart item web component
     *
     * @constructor
     */
    constructor() {
      super();
      window.theme.cart.get().then((cart) => {
        this.render(cart);
        this.calculateCartTotal(cart);
      });
    }

    render(cart) {
      this.innerHTML = `
        <div class="cart-total-price">${theme.money.format(
          cart.total_price
        )}</div>
      `;
    }

    calculateCartTotal(cart) {
      // async calls to getItemTotal await for the responses to add to the totals
      Promise.all(cart.items.map(this.getItemTotal.bind(this))).then(
        (totals) => {
          console.log("totals", totals);
          const total = totals.reduce((acc, total) => acc + total, 0);

          this.querySelector(".cart-total-price").innerHTML =
            theme.money.format(total);
        }
      );
    }

    async getItemTotal(cartItem) {
      try {
        const boldCustomAppUrl =
          "https://api.boldcommerce.com/go_pre/pricerules/0ccab2.myshopify.com";
        const url = `${boldCustomAppUrl}/rulesets?products=${cartItem.product_id}`;
        const response = await fetch(url);
        const data = await response.json();

        if (data.rulesets.length) {
          this.rulesSets = data.rulesets.map((ruleset) => {
            return {
              variantId: ruleset.product_selection.products[0].variant_id,
              rules: ruleset.rules.filter((rule) => rule.type === "DISPLAY"),
            };
          });

          const ruleset = this.rulesSets.find(
            (ruleset) => ruleset.variantId == cartItem.variant_id
          );
          const quantityBreaks = this.getQuantityBreaks(ruleset);

          const intervals = [];
          let minQty = 1;
          let currentPrice = cartItem.final_price;

          quantityBreaks.forEach((element) => {
            intervals.push({
              min: minQty,
              max: element.qty - 1,
              price: currentPrice,
            });
            currentPrice = element.price;
            minQty = element.qty;
          });
          intervals.push({
            min: minQty,
            max: 9999999,
            price: currentPrice,
          });

          const interval = intervals.find((interval) => {
            if (
              cartItem.quantity >= interval.min &&
              cartItem.quantity <= interval.max
            ) {
              return true;
            }
          });

          if (interval) {
            return interval.price * cartItem.quantity;
          } else {
            return cartItem.final_line_price;
          }
        } else {
          return cartItem.final_line_price;
        }
      } catch (error) {
        return cartItem.final_line_price;
      }
    }

    getQuantityBreaks(ruleset) {
      const quantityBreaks = [];
      ruleset.rules.forEach((rule) => {
        rule.actions.forEach((action) => {
          if (action.type === "DISPLAY_QTY_BREAK") {
            quantityBreaks.push(action);
          }
        });
      });

      return quantityBreaks;
    }

    log(info) {
      console.log("cart-total-price", JSON.stringify(info));
    }
  }

  customElements.define(customElements.component, cartTotalPrice);
}
